const moduleNameKey = "staticLink";

export const staticLinkEn = {
  [moduleNameKey]: {
    contentLabel: "Content",
    contentPlaceholder: "Enter text",
    fontSizeLabel: "Font size",
    alignmentLabel: "Alignment",
    alignmentLeft: "Left",
    alignmentCenter: "Center",
    alignmentRight: "Right",
    fontColorLabel: "Font color",
    transparentLabel: "Transparent background",
    dashboardLinkLabel: "Dashboard link",
    dashboardLinkPlaceholder: "Search dashboards...",
    noDashboards: "No dashboards found",
    dashboardLinkRequired: "A link to a dashboard must be set",
    saveButton: "Save",
    cancelButton: "Cancel",
  },
};

export const staticLinkPtBr = {
  [moduleNameKey]: {
    contentLabel: "Conteúdo",
    contentPlaceholder: "Digite o texto",
    fontSizeLabel: "Tamanho da fonte",
    alignmentLabel: "Alinhamento",
    alignmentLeft: "Esquerda",
    alignmentCenter: "Centro",
    alignmentRight: "Direita",
    fontColorLabel: "Cor da fonte",
    transparentLabel: "Fundo transparente",
    dashboardLinkLabel: "Link do painel",
    dashboardLinkPlaceholder: "Buscar painéis...",
    noDashboards: "Nenhum painel encontrado",
    dashboardLinkRequired: "É preciso definir um link para um painel",
    saveButton: "Salvar",
    cancelButton: "Cancelar",
  },
};

export const staticLinkDe = {
  [moduleNameKey]: {
    contentLabel: "Inhalt",
    contentPlaceholder: "Text eingeben",
    fontSizeLabel: "Schriftgröße",
    alignmentLabel: "Ausrichtung",
    alignmentLeft: "Links",
    alignmentCenter: "Mitte",
    alignmentRight: "Rechts",
    fontColorLabel: "Schriftfarbe",
    transparentLabel: "Transparenter Hintergrund",
    dashboardLinkLabel: "Dashboard-Link",
    dashboardLinkPlaceholder: "Dashboards suchen...",
    noDashboards: "Keine Dashboards gefunden",
    dashboardLinkRequired:
      "Es muss ein Link zu einem Dashboard festgelegt werden",
    saveButton: "Speichern",
    cancelButton: "Abbrechen",
  },
};

export const staticLinkZhHans = {
  [moduleNameKey]: {
    contentLabel: "内容",
    contentPlaceholder: "输入文本",
    fontSizeLabel: "字体大小",
    alignmentLabel: "对齐",
    alignmentLeft: "左",
    alignmentCenter: "居中",
    alignmentRight: "右",
    fontColorLabel: "字体颜色",
    transparentLabel: "透明背景",
    dashboardLinkLabel: "仪表板链接",
    dashboardLinkPlaceholder: "搜索仪表板...",
    noDashboards: "未找到仪表板",
    dashboardLinkRequired: "必须设置一个仪表板链接",
    saveButton: "保存",
    cancelButton: "取消",
  },
};

export const staticLinkIt = {
  [moduleNameKey]: {
    contentLabel: "Contenuto",
    contentPlaceholder: "Inserisci testo",
    fontSizeLabel: "Dimensione testo",
    alignmentLabel: "Allineamento",
    alignmentLeft: "Sinistra",
    alignmentCenter: "Centro",
    alignmentRight: "Destra",
    fontColorLabel: "Colore testo",
    transparentLabel: "Sfondo trasparente",
    dashboardLinkLabel: "Link dashboard",
    dashboardLinkPlaceholder: "Cerca dashboard...",
    noDashboards: "Nessuna dashboard trovata",
    dashboardLinkRequired: "È necessario impostare un link a una dashboard",
    saveButton: "Salva",
    cancelButton: "Annulla",
  },
};

export const staticLinkEs = {
  [moduleNameKey]: {
    contentLabel: "Contenido",
    contentPlaceholder: "Ingrese texto",
    fontSizeLabel: "Tamaño de fuente",
    alignmentLabel: "Alineación",
    alignmentLeft: "Izquierda",
    alignmentCenter: "Centro",
    alignmentRight: "Derecha",
    fontColorLabel: "Color de fuente",
    transparentLabel: "Fondo transparente",
    dashboardLinkLabel: "Enlace del panel",
    dashboardLinkPlaceholder: "Buscar paneles...",
    noDashboards: "No se encontraron paneles",
    dashboardLinkRequired: "Debe establecerse un enlace a un panel",
    saveButton: "Guardar",
    cancelButton: "Cancelar",
  },
};

export const staticLinkNl = {
  [moduleNameKey]: {
    contentLabel: "Inhoud",
    contentPlaceholder: "Typ tekst",
    fontSizeLabel: "Tekstgrootte",
    alignmentLabel: "Uitlijning",
    alignmentLeft: "Links",
    alignmentCenter: "Midden",
    alignmentRight: "Rechts",
    fontColorLabel: "Tekstkleur",
    transparentLabel: "Transparante achtergrond",
    dashboardLinkLabel: "Dashboardlink",
    dashboardLinkPlaceholder: "Dashboards zoeken...",
    noDashboards: "Geen dashboards gevonden",
    dashboardLinkRequired: "Een dashboardlink moet ingesteld zijn",
    saveButton: "Opslaan",
    cancelButton: "Annuleren",
  },
};

export const staticLinkTr = {
  [moduleNameKey]: {
    contentLabel: "İçerik",
    contentPlaceholder: "Metni girin",
    fontSizeLabel: "Yazı tipi boyutu",
    alignmentLabel: "Hizalama",
    alignmentLeft: "Sol",
    alignmentCenter: "Merkez",
    alignmentRight: "Sağ",
    fontColorLabel: "Yazı tipi rengi",
    transparentLabel: "Saydam arka plan",
    dashboardLinkLabel: "Kontrol paneli bağlantısı",
    dashboardLinkPlaceholder: "Kontrol panellerinde ara...",
    noDashboards: "Kontrol paneli bulunamadı",
    dashboardLinkRequired: "Bir kontrol paneli bağlantısı ayarlanmalıdır",
    saveButton: "Kaydetmek",
    cancelButton: "İptal etmek",
  },
};
